import script from "./SocialConsentGuideModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialConsentGuideModal.vue?vue&type=script&setup=true&lang=js"

import "./SocialConsentGuideModal.vue?vue&type=style&index=0&id=9f56e89c&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../jump-dev-merge/서버/jump/jump-user/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f56e89c"]])

export default __exports__